import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function JobBrowserSkeleton({ isDarkMode }) {
    const cardCls = `rounded-2xl border shadow-sm ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"}`;
    const dividerColor = isDarkMode ? "#334155" : "#f1f5f9";
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <div className="max-w-7xl mx-auto px-4 py-4 md:py-8">
                    <div className="mb-5 md:mb-6">
                        <Skeleton width={200} height={28} />
                        <Skeleton width={260} height={16} className="mt-2" />
                    </div>

                    <div className={`${cardCls} p-4 mb-6`}>
                        <Skeleton height={40} className="mb-3" />
                        <div className="flex gap-2">
                            <Skeleton width={96} height={36} borderRadius={8} />
                            <Skeleton width={96} height={36} borderRadius={8} />
                        </div>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className={`${cardCls} p-4 md:p-6`}>
                                <Skeleton width="70%" height={20} />
                                <Skeleton width="45%" height={14} className="mt-2" />
                                <Skeleton width="55%" height={14} className="mt-2" />
                                <div
                                    className="mt-4 pt-3 md:pt-4 border-t flex items-center justify-between"
                                    style={{ borderColor: dividerColor }}
                                >
                                    <Skeleton width={110} height={12} />
                                    <Skeleton width={90} height={32} borderRadius={8} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    );
}
